(function () {
  'use strict';

  angular.module('mobile.lead.add', ['ui.router']);
})();
